import * as React from 'react';

import {ConfirmationDialog} from '../confirmation-dialog/confirmation-dialog';
import {DisabledSection} from '../disabled-section/disabled-section';
import {FlashBanner} from '../flash-banner/flash-banner';
import {LoadingPage} from '../loading-page/loading-page';
import {PageHeader} from '../page-header/page-header';
import {PlanUpgradeLink} from '../upgrade/plan-upgrade-link';

import styles from './prepare-to-send-wrapper.module.css';

type Props = {
    content: React.ReactNode;
    footerBar: React.ReactNode;
    isFirstPage: boolean;
    userFacingNoun: string;
    name?: string;
    isLoading: boolean;
    errorMessage: string | null | undefined;
    shouldDisable: boolean;
    onClose: () => void;
    showUpgradeBanner: boolean;
};

export function PrepareToSendWrapper(props: Props) {
    const [isConfirmingGoBack, setIsConfirmingGoBack] = React.useState(false);

    const errorBanner = props.errorMessage && (
        <div className='py-8 px-16'>
            <FlashBanner type='warning' animate={false} hasBorder={true}>
                <div className='full-width flex justify-sb'>
                    {props.errorMessage}
                    <div className={styles['flash-banner-cta-container']}>
                        {props.showUpgradeBanner && <PlanUpgradeLink />}
                    </div>
                </div>
            </FlashBanner>
        </div>
    );

    return (
        <>
            <div className='flex flex-dir-col full-width full-height border-box pos-absolute background-white border-top-left-8'>
                <PageHeader
                    backButton={{
                        onClick: () => {
                            if (props.isFirstPage) {
                                props.onClose();

                                setIsConfirmingGoBack(false);
                            } else {
                                setIsConfirmingGoBack(true);
                            }
                        },
                        text: `Back to ${props.userFacingNoun}`,
                    }}
                    title={`Prepare to send ${props.name || props.userFacingNoun}`}
                />
                {errorBanner}
                {props.isLoading ? (
                    <LoadingPage size={40} />
                ) : (
                    <div className='flex flex-dir-col flex-grow overflow-auto full-height'>
                        {errorBanner && props.shouldDisable ? (
                            <DisabledSection>{props.content}</DisabledSection>
                        ) : (
                            props.content
                        )}
                    </div>
                )}
                <div className='border-top px-16'>{props.footerBar}</div>
            </div>
            {isConfirmingGoBack && (
                <ConfirmationDialog
                    title={`Back to ${props.userFacingNoun}`}
                    message='If you leave now, your selections will be discarded. Would you like to go back?'
                    confirmText='Yes, go back'
                    cancelText='No, stay here'
                    onCancel={() => {
                        setIsConfirmingGoBack(false);
                    }}
                    onConfirm={() => {
                        props.onClose();
                        setIsConfirmingGoBack(false);
                    }}
                    isConfirmDestructive={true}
                />
            )}
        </>
    );
}
